<template>
    <v-btn-toggle v-model="cardAction">
        <v-btn @click="deleteOrder">
            <v-icon>delete_outline</v-icon>
        </v-btn>
        <v-btn v-if="!isOften" @click="addToOften">
            <v-icon>add</v-icon>
        </v-btn>
        <v-btn v-if="isOften" @click="deleteOften">
            <v-icon>highlight_off</v-icon>
        </v-btn>
        <v-btn @click="openMessages">
            <v-icon>email</v-icon>
        </v-btn>
    </v-btn-toggle>
</template>

<script>
    export default {
        name: "BasketCardActions",
        props:['isOften'],
        data(){
            return {
                cardAction: null
            }
        },
        methods:{
            addToOften(){
                this.$emit('add-to-often');
            },
            deleteOften(){
                this.$emit('delete-often');
            },
            deleteOrder(){
                this.$emit('delete-order');
            },
            openMessages(){
                this.$emit('open-messages')
            }
        }
    }
</script>

<style scoped>

</style>
